// extracted by mini-css-extract-plugin
export default {"content":"OperationBudget_content__s6QLI"};